<template>
  <div>
    <div 
      id="sidebar-main" 
      :class="{'open': mobileSidebarOpen }"
    >
      <router-link class="brand" to="/" @click.native="clearFilters()">UserStock</router-link> 
      <header @click="mobileSidebarOpen = !mobileSidebarOpen"><span>Refine Results</span></header>
      <div class="form">
        <div class="form-group group-gender">
          <label>Gender</label>
          <!-- TODO: make this a loop based on the filter data model -->
          <div class="options options-gender">
            <div 
              class="toggle fa fa-female"
              :class="{'active': (genderFilter == 'female') ? true : false}"
              @click="handleFilter('gender','female',$event)"
            ></div>
            <div 
              class="toggle fa fa-male"
              :class="{'active': (genderFilter == 'male') ? true : false}"
              @click="handleFilter('gender','male',$event)"
            ></div>
          </div>
        </div>
        <div class="form-group group-age">
          <label>Age group</label>
          <div class="container-select">
            <select class="dropdown" name="" @change="handleFilter('age','',$event)">
              <option value="all">All</option>
              <option value="age-0">Child</option>
              <option value="age-1">Young adult</option>
              <option value="age-2">20/30 something</option>
              <option value="age-3">Middle-aged</option>
              <option value="age-4">Senior</option>
            </select>
          </div>
        </div>
        <div class="form-group group-style">
          <label>Image style</label>
          <div class="container-select">
            <select class="dropdown" name="" @change="handleFilter('style','',$event)">
              <option value="all">All</option>
              <option value="style-color">Color</option>
              <option value="style-bw">Black &amp; White</option>
              <option value="style-simple-bg">Simple Background</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="wrap container-fluid">
      <div class="content row">
        <main class="main">
          <div class="row">
            <div 
              v-for="(photo, index) in photos"
              :key="index"
              class="hentry list-item type-photo"
              v-cloak
            >
              <div class="inner">
                <div class="crop">
                  <router-link :to="{ name: 'photo', params: { id: photo.id }}" class="image" v-bind:style="{ background: 'url('+ photo._embedded['wp:featuredmedia']['0'].media_details.sizes.thumbnail.source_url +') center center / cover no-repeat' }">
                  </router-link>
                  <div class="toolbar">
                    <a v-bind:href="photo._embedded['wp:featuredmedia']['0'].media_details.sizes.full.source_url" class="fa fa-download" target="_blank"></a>
                  </div>
                </div>

                <!-- <a v-bind:href="photo.url" class="image" v-bind:style="{ background: 'url('+ photo.thumbnail +') center center / cover no-repeat' }"></a> -->

              </div>
            </div>
            <div
              v-if="photos && photos.length == 0"
              class="alert alert-warning no-results"
            >
              Sorry, no results were found. Please try clearing some filters.
            </div>
          </div>
          <Icon v-if="photosAreLoading && currentPhotoPage < totalPhotoPages" name="loader" />
        </main>
      </div>
    </div>
    <router-view name="photo" />
  </div>
</template>

<script>
import axios from 'axios'
import Icon from '@/components/Icon.vue'
import Vue from 'vue'
import VueHead from 'vue-head'

Vue.use(VueHead)

export default {
  name: 'home',
  components: {
    Icon,
  },
  data () {
    return {
      photos: null,
      scrollLoadThreshold: 300,
      photosAreLoading: false,
      photosPerPage: 40,
      currentPhotoPage: 1,
      totalPhotoPages: 1,
      genderFilter: null,
      ageFilter: null,
      styleFilter: null,
    }
  },
  computed: {
    apiURL: function() {
      let url = this.$store.state.baseURL + 'wp-json/wp/v2/photos/?_embed&per_page='+this.photosPerPage+'&page='+this.currentPhotoPage
      if (this.genderFilter || this.ageFilter || this.styleFilter) {
        url += '&filter[tag]='+this.urlFilterString
      }
      return url
    },
    urlFilterString: function () {
      let filterString = (this.genderFilter) ? this.genderFilter + "+" : ""
      filterString += (this.ageFilter) ? this.ageFilter + "+" : ""
      filterString += (this.styleFilter) ? this.styleFilter + "+" : ""
      // Trim the trailing '+', if there is one
      filterString = (filterString !== "") ? filterString.substring(0, filterString.length - 1) : filterString
      return filterString
    },
    mobileSidebarOpen: {
      get: function () {
        return this.$store.state.mobileSidebarOpen
      },
      set: function (val) {
        this.$store.commit('updateMobileSidebarOpen', val)
      }
    }
  },
  methods: {
    toggleMobileSidebar: function () {
      this.mobileSidebarOpen = !this.mobileSidebarOpen
      this.$emit('mobile-sidebar-toggled', this.mobileSidebarOpen)
    },
    fetchPhotos: function () {
      let that = this
      this.photosAreLoading = true
      axios
        .get(this.apiURL)
        .then(function(response) {
          const data = response.data
          that.totalPhotoPages = parseInt(response.headers['x-wp-totalpages'])
          if(!that.photos) {
            that.photos = data
          } else {
            for (var i = 0; i < data.length; i++) {
              that.photos.push(data[i]);
            }
          }
          
          // Debounce the loading and load more if it's the initial load and a tall viewport
          setTimeout(function() {
            that.photosAreLoading = false
            // 116 = the height of the image vertical margin and the loader
            if(that.currentPhotoPage < 2 && (document.body.scrollHeight-116) < window.innerHeight && that.totalPhotoPages > 1) {
              that.handleScroll()
            }
          }, 1000)
        })
    },
    handleFilter: function(filter, value, event) {
      switch (filter) {
        case 'gender':
          if(value == this.genderFilter) {
            this.genderFilter = null
          }else {
            this.genderFilter = value
          }
          break
        case 'age':
          this.ageFilter = (event.target.value === 'all') ? null : event.target.value
          break
        case 'style':
          this.styleFilter = (event.target.value === 'all') ? null : event.target.value
          break
      }
      // Clear the photos array and reset the page counter before getting the filtered photos
      this.currentPhotoPage = 1
      this.photos = null
      this.fetchPhotos()
    },
    clearFilters: function () {
      this.genderFilter = null
      this.ageFilter = null
      this.styleFilter = null
      this.handleFilter()
    },
    handleScroll: function () {
      if ((window.scrollY + this.scrollLoadThreshold) >= (document.body.scrollHeight - window.innerHeight) ) {
        if (!this.photosAreLoading && this.currentPhotoPage < this.totalPhotoPages) {
          this.currentPhotoPage++
          this.fetchPhotos()
        }
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted () {
    this.fetchPhotos()
  },
  head: {
    title: {
      inner: 'UserStock',
      complement: 'Face photos for UI mockups'
    },
    meta: [
      { name: 'description', content: "Free photos of people's faces to use as avatars in UI mockups, prototypes and more." },
      { property: 'og:title', content: 'UserStock | Face photos for UI mockups' },
      { property: 'og:type', content: 'website' },
      // { property: 'og:image', content: 'https://userstock.io/userstock_og.png' },
      { property: 'og:url', content: 'https://userstock.io' },
      { property: 'og:description', content: "Free photos of people's faces to use as avatars in UI mockups, prototypes and more." },
    ]
  }
}
</script>
